import appsettings from "@/store/app-settings";
import { axiosPost } from "@/store/api/axiosUtils.js";

// OTHER
const GetOther_ProvinceName = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetOther_ProvinceName",
    params
  );
};

// LINE CHART
// ===============
const GetLineChart_ComplaintPerMonth = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetLineChart_ComplaintPerMonth",
    params
  );
};

// PIE CHART
// ===============
const GetPieChart_WebService = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetPieChart_WebService",
    params
  );
};
// const GetPieChart_ContinueAndTerminateStatus = (params) => {
//   return axiosPost(
//     appsettings.ocpbComplaintAPIUrl +
//       "api/Dashboard/GetPieChart_ContinueAndTerminateStatus",
//     params
//   );
// };
const GetPieChart_ResultsTheLegalDeptInquiry = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_ResultsTheLegalDeptInquiry",
    params
  );
};
const GetPieChart_ComplaintSendToOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_ComplaintSendToOfficer",
    params
  );
}; 
const GetPieChart_TrackingComplaintStatus = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_TrackingComplaintStatus",
    params
  ); 
}; 
const GetPieChart_DocumentStatusForOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_DocumentStatusForOfficer",
    params
  ); 
};
const GetPieChart_ComplaintSendToOutSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetPieChart_ComplaintSendToOutSiteDepartment",
    params
  ); 
};

// BAR CHART
// ===============
const GetBarChart_ComplaintSendToOutSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_ComplaintSendToOutSiteDepartment",
    params
  );
};
const GetBarChart_ComplaintSendToInSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_ComplaintSendToInSiteDepartment",
    params
  );
}; 
// const GetBarChart_WaitingToBeSigned = (params) => {
//   return axiosPost(
//     appsettings.ocpbComplaintAPIUrl +
//       "api/Dashboard/GetBarChart_WaitingToBeSigned",
//     params
//   );
// }; 
const GetBarChart_DocumentStatusForLeader = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_DocumentStatusForLeader",
    params
  ); 
};

// BOX CHART
// ===============
const GetBoxChart_SummaryComplaint = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryComplaint",
    params
  );
};
const GetBoxChart_SummaryWebService = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryWebService",
    params
  );
};
const GetBoxChart_SummaryRequestAdditionalDocument = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryRequestAdditionalDocument",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOutSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOutSiteDepartment",
    params
  );
};
const GetBoxChart_SummaryComplaintTerminate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintTerminate",
    params
  );
};
const GetBoxChart_SummaryComplaintReturnToOriginalDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintReturnToOriginalDepartment",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToInSiteDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToInSiteDepartment",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOfficer",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForOfficer",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForLeader = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForLeader",
    params
  );
}; 
const GetBoxChart_SummaryComplaintSendToCenter = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToCenter",
    params
  );
}; 
const GetBoxChart_SummaryComplaint_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryComplaint_Details",
    params
  );
};
const GetBoxChart_SummaryWebService_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Dashboard/GetBoxChart_SummaryWebService_Details",
    params
  );
};
const GetBoxChart_SummaryRequestAdditionalDocument_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryRequestAdditionalDocument_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOutSiteDepartment_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOutSiteDepartment_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintTerminate_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintTerminate_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintReturnToOriginalDepartment_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintReturnToOriginalDepartment_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToInSiteDepartment_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToInSiteDepartment_Details",
    params
  );
};
const GetBoxChart_SummaryComplaintSendToOfficer_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToOfficer_Details",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForOfficer_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForOfficer_Details",
    params
  );
}; 
const GetBoxChart_SummaryDocumentWaitingApproveForLeader_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryDocumentWaitingApproveForLeader_Details",
    params
  );
}; 
const GetBoxChart_SummaryComplaintSendToCenter_Details = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryComplaintSendToCenter_Details",
    params
  );
}; 

// FASTTRACK
const GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany",
    params
  );
}; 
const GetBarChart_SummaryFasttrackTransactionUser = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_SummaryFasttrackTransactionUser",
    params
  );
}; 
const GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Dashboard/GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany",
    params
  );
};
// FASTTRACK

export {
  // OTHER
  // ===============
  GetOther_ProvinceName,
  // LINE CHART
  // ===============
  GetLineChart_ComplaintPerMonth,
  // PIE CHART
  // ===============
  GetPieChart_WebService,
  // GetPieChart_ContinueAndTerminateStatus,
  GetPieChart_ResultsTheLegalDeptInquiry,
  GetPieChart_ComplaintSendToOfficer,
  GetPieChart_TrackingComplaintStatus,
  GetPieChart_DocumentStatusForOfficer,
  GetPieChart_ComplaintSendToOutSiteDepartment,
  // BAR CHART
  // ===============
  GetBarChart_ComplaintSendToInSiteDepartment,
  GetBarChart_ComplaintSendToOutSiteDepartment,
  // GetBarChart_WaitingToBeSigned,
  GetBarChart_DocumentStatusForLeader,
  // BOX CHART
  // ===============
  GetBoxChart_SummaryComplaint,
  GetBoxChart_SummaryWebService,
  GetBoxChart_SummaryRequestAdditionalDocument,
  GetBoxChart_SummaryComplaintSendToOutSiteDepartment,
  GetBoxChart_SummaryComplaintSendToInSiteDepartment,
  GetBoxChart_SummaryComplaintTerminate,
  GetBoxChart_SummaryComplaintReturnToOriginalDepartment,
  GetBoxChart_SummaryComplaintSendToOfficer,
  GetBoxChart_SummaryDocumentWaitingApproveForOfficer,
  GetBoxChart_SummaryDocumentWaitingApproveForLeader,
  GetBoxChart_SummaryComplaintSendToCenter,
  // BOX CHART DETAILS
  // ===============
  GetBoxChart_SummaryComplaint_Details,
  GetBoxChart_SummaryWebService_Details,
  GetBoxChart_SummaryRequestAdditionalDocument_Details,
  GetBoxChart_SummaryComplaintSendToOutSiteDepartment_Details,
  GetBoxChart_SummaryComplaintSendToInSiteDepartment_Details,
  GetBoxChart_SummaryComplaintTerminate_Details,
  GetBoxChart_SummaryComplaintReturnToOriginalDepartment_Details,
  GetBoxChart_SummaryComplaintSendToOfficer_Details,
  GetBoxChart_SummaryDocumentWaitingApproveForOfficer_Details,
  GetBoxChart_SummaryDocumentWaitingApproveForLeader_Details,
  GetBoxChart_SummaryComplaintSendToCenter_Details,
  // FASTTRACK
  // ===============
  GetBoxChart_SummaryFasttrackAttorneyUnderMouCompany,
  GetBarChart_SummaryFasttrackTransactionUser,
  GetBarChart_SummaryFasttrackSendToAndRecieveFromCompany

};